import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M13.037 9.575C13.629 8.878 14 7.986 14 7c0-2.209-1.791-4-4-4H5v14h6c2.209 0 4-1.791 4-4 0-1.462-.792-2.727-1.963-3.425zM7.5 5.5H10c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5H7.5v-3zm3.5 9H7.5v-3H11c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5z',
  ],
  height: 20,
  width: 20,
});
